import "core-js/modules/es.array.includes.js";
import { getZendeskChatToken } from "./monolith";
var script = null;
function createSettingsChat() {
  if (window.zESettings) {
    return;
  }
  window.zESettings = {
    webWidget: {
      authenticate: {
        chat: {
          jwtFn: function jwtFn(callback) {
            getZendeskChatToken().then(function (data) {
              callback(data.data.token);
            });
          }
        }
      },
      contactForm: {
        suppress: true
      },
      contactOptions: {
        enabled: false
      },
      chat: {
        departments: {
          enabled: []
        }
      },
      zIndex: 100,
      launcher: {
        chatLabel: {
          '*': 'Live Chat'
        }
      }
    }
  };
}
function createSettingsChatAndRecruiterForm() {
  if (window.zESettings) {
    return;
  }
  window.zESettings = {
    webWidget: {
      authenticate: {
        chat: {
          jwtFn: function jwtFn(callback) {
            getZendeskChatToken().then(function (data) {
              callback(data.data.token);
            });
          }
        }
      },
      contactForm: {
        ticketForms: [{
          id: 8345507730317
        }]
      },
      contactOptions: {
        enabled: true,
        chatLabelOnline: {
          '*': 'Live Chat'
        },
        chatLabelOffline: {
          '*': 'Chat is unavailable'
        },
        contactFormLabel: {
          '*': 'Recruiter Change Request'
        }
      },
      zIndex: 100,
      launcher: {
        chatLabel: {
          '*': 'Help'
        }
      }
    }
  };
}
function getKey() {
  return window.ZENDESK_WIDGET_KEY;
}
function createScript(key) {
  script = document.createElement('script');
  script.src = "https://static.zdassets.com/ekr/snippet.js?key=".concat(key);
  // Removing this unused id causes a "Key is missing from snippet" error
  script.id = 'ze-snippet';
  return script;
}
function createSettings(activeUserRole) {
  var _options$allowForm;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var allowForm = (_options$allowForm = options.allowForm) !== null && _options$allowForm !== void 0 ? _options$allowForm : true;
  if (allowForm && ['studentWithAgent', 'agent'].includes(activeUserRole)) {
    return createSettingsChatAndRecruiterForm();
  }
  if (activeUserRole == 'studentNoAgent' || !allowForm) {
    return createSettingsChat();
  }
}
export function init(onReady, activeUserRole, options) {
  if (script !== null) return;
  createSettings(activeUserRole, options);
  script = createScript(getKey());
  script.onload = function () {
    var _options$onReady;
    onReady();
    options === null || options === void 0 ? void 0 : (_options$onReady = options.onReady) === null || _options$onReady === void 0 ? void 0 : _options$onReady.call(options);
  };
  document.body.appendChild(script);
}
export function onDepartmentStatus(callback) {
  window.zE('webWidget:on', 'chat:departmentStatus', callback);
}
export function hide() {
  window.zE('webWidget', 'hide');
}
export function show() {
  window.zE('webWidget', 'show');
}
export function open() {
  window.zE('webWidget', 'open');
}
export function onWebWidgetOpen(callback) {
  window.zE('webWidget:on', 'open', callback);
}
export function onClose(callback) {
  window.zE('webWidget:on', 'close', callback);
}
export function onChatEnd(callback) {
  window.zE('webWidget:on', 'chat:end', callback);
}
export function onChatStart(callback) {
  window.zE('webWidget:on', 'chat:start', callback);
}
export function sendMessage(message) {
  window.zE('webWidget', 'chat:send', message);
}
export function addTags(tags) {
  window.zE('webWidget', 'chat:addTags', tags);
}
export function removeTags(tags) {
  window.zE('webWidget', 'chat:removeTags', tags);
}
export function onChatOpened(callback) {
  window.zE('webWidget:on', 'userEvent', function (userEvent) {
    if (userEvent.action === 'Chat Opened') {
      callback();
    }
  });
}
export function onWebWidgetMinimized(callback) {
  window.zE('webWidget:on', 'userEvent', function (userEvent) {
    if (userEvent.action === 'Web Widget Minimised') {
      callback();
    }
  });
}
export function selectDepartment(departmentName) {
  updateSettings({
    chat: {
      departments: {
        select: departmentName
      }
    }
  });
}
export function updateSettings(newSettings) {
  window.zE('webWidget', 'updateSettings', {
    webWidget: newSettings
  });
}